import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import rel from '@ifeng-fe/container_channel/common/client/utils/rel';
import Search from '@ifeng-fe/ui_pc_search';
import Ad from '@ifeng-fe/ui_pc_ad';

/**
 * for this page
 */
class PhotoNav extends React.PureComponent {
    state = {
        defaultValue: '中医将入WHO全球医学纲要',
    };

    static propTypes = {
        searchData: PropTypes.array,
        ad: PropTypes.object,
    };

    render() {
        // console.log(this.props);
        const { searchData, ad } = this.props;

        /**
         * 组件分发数据
         */

        return (
            <div className={styles.photoNav}>
                <div className={styles.col_w1230}>
                    <div className={`${styles.top} clearfix`}>
                        <div className={styles.logo}>
                            <a href="#" target="_blank">
                                <img
                                    src="http://p3.ifengimg.com/37780e23b9ea2d8b/2017/38/logoPhoto.png"
                                    width="161"
                                    height="27"
                                    alt="凤凰网图片"
                                    rel={rel}
                                />
                            </a>
                        </div>
                        <div className={styles.lineT} />
                        {/* 头部频道冠名标签 */}
                        <div className={styles.ad_h}>
                            <Ad content={ad} />
                        </div>
                        <div className={styles.searchWrapper}>
                            <Chip
                                id="10129"
                                type="static"
                                title="通用搜索"
                                groupName="凤凰网资讯图片"
                                content={searchData}>
                                <Search />
                            </Chip>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(PhotoNav);
